var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnssea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 38,
    viewBox: "0 0 259 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M196 29.0479L202.072 16.0361L202.94 13L209.879 29.0479H196Z",
    fill: "#CF1463"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65 12H83V25H65V12Z",
    fill: "#CF1463"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83 21H72V17H83V21ZM83 9V13H67V25H83V29H63V9H83Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7812 15V29H86.7812V9H90.7812L102.781 23V9H106.781V29H102.781L90.7812 15Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M133 29H109V25H133C133.562 25 134.031 24.8125 134.406 24.4375C134.802 24.0417 135 23.5625 135 23C135 22.4375 134.802 21.9688 134.406 21.5938C134.031 21.1979 133.562 21 133 21H125C123.333 21 121.917 20.4167 120.75 19.25C119.583 18.0833 119 16.6667 119 15C119 13.3333 119.583 11.9167 120.75 10.75C121.917 9.58333 123.333 9 125 9H137V13H125C124.438 13 123.958 13.1979 123.562 13.5938C123.188 13.9688 123 14.4375 123 15C123 15.5625 123.188 16.0417 123.562 16.4375C123.958 16.8125 124.438 17 125 17H133C134.667 17 136.083 17.5833 137.25 18.75C138.417 19.9167 139 21.3333 139 23C139 24.6667 138.417 26.0833 137.25 27.25C136.083 28.4167 134.667 29 133 29Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M163.875 29H139.875V25H163.875C164.438 25 164.906 24.8125 165.281 24.4375C165.677 24.0417 165.875 23.5625 165.875 23C165.875 22.4375 165.677 21.9688 165.281 21.5938C164.906 21.1979 164.438 21 163.875 21H155.875C154.208 21 152.792 20.4167 151.625 19.25C150.458 18.0833 149.875 16.6667 149.875 15C149.875 13.3333 150.458 11.9167 151.625 10.75C152.792 9.58333 154.208 9 155.875 9H167.875V13H155.875C155.312 13 154.833 13.1979 154.438 13.5938C154.062 13.9688 153.875 14.4375 153.875 15C153.875 15.5625 154.062 16.0417 154.438 16.4375C154.833 16.8125 155.312 17 155.875 17H163.875C165.542 17 166.958 17.5833 168.125 18.75C169.292 19.9167 169.875 21.3333 169.875 23C169.875 24.6667 169.292 26.0833 168.125 27.25C166.958 28.4167 165.542 29 163.875 29Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M191.938 21H180.938V17H191.938V21ZM191.938 9V13H175.938V25H191.938V29H171.938V9H191.938Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M192.938 29L202.938 8L212.938 29H208.438L202.938 17.5L197.438 29H192.938Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnssea);
export default __webpack_public_path__ + "static/media/enssea.718c0fb239b12294f87f51831676ba36.svg";
export { ForwardRef as ReactComponent };